import { create } from "zustand";

interface TutorDashboardState {
  // UI State only - session data now comes from React Query
  showWelcomeMessage: boolean;
  selectedDate: Date;
  pastSessionsPage: number;
  pastSessionsFilter: string;

  // Actions
  setShowWelcomeMessage: (show: boolean) => void;
  setSelectedDate: (date: Date) => void;
  setPastSessionsPage: (page: number) => void;
  setPastSessionsFilter: (filter: string) => void;
}

export const useTutorDashboardStore = create<TutorDashboardState>((set) => ({
  // Initial UI state only - session data now comes from React Query
  showWelcomeMessage: false,
  selectedDate: new Date(),
  pastSessionsPage: 1,
  pastSessionsFilter: "Last 7 days",

  // Actions
  setShowWelcomeMessage: (show) => set({ showWelcomeMessage: show }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setPastSessionsPage: (page) => set({ pastSessionsPage: page }),
  setPastSessionsFilter: (filter) => set({ pastSessionsFilter: filter }),
}));